import { render } from "./electricalEdit.vue?vue&type=template&id=0496fa2f"
import script from "./electricalEdit.vue?vue&type=script&lang=js"
export * from "./electricalEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__